module.exports = __webpack_public_path__ + "media/images/img_service_4-55e1e7f55c93f1f19020a878c1e28a2e.png";